export default {
  classifieds: state => state.classifieds,
  classifiedInfos: state => state.classifiedInfos,
  totalPages: state => state.totalPages
}
